import { html } from 'lit';

export const iconPdf = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 14 19"
    fill="none"
  >
    <g clip-path="url(#clip0_314_3)">
      <path
        d="M1.75 14.4375H3.0625V15.75H1.75C0.765625 15.75 0 14.9844 0 14V3.5C0 2.54297 0.765625 1.75 1.75 1.75H6.26172C6.72656 1.75 7.16406 1.94141 7.49219 2.26953L9.98047 4.75781C10.3086 5.08594 10.5 5.52344 10.5 5.98828V10.0625H9.1875V6.125H7C6.50781 6.125 6.125 5.74219 6.125 5.25V3.0625H1.75C1.50391 3.0625 1.3125 3.28125 1.3125 3.5V14C1.3125 14.2461 1.50391 14.4375 1.75 14.4375ZM4.8125 11.375H5.6875C6.50781 11.375 7.21875 12.0859 7.21875 12.9062C7.21875 13.7539 6.50781 14.4375 5.6875 14.4375H5.25V15.3125C5.25 15.5586 5.03125 15.75 4.8125 15.75C4.56641 15.75 4.375 15.5586 4.375 15.3125V14V11.8125C4.375 11.5937 4.56641 11.375 4.8125 11.375ZM5.6875 13.5625C6.04297 13.5625 6.34375 13.2891 6.34375 12.9062C6.34375 12.5508 6.04297 12.25 5.6875 12.25H5.25V13.5625H5.6875ZM8.3125 11.375H9.1875C9.89844 11.375 10.5 11.9766 10.5 12.6875V14.4375C10.5 15.1758 9.89844 15.75 9.1875 15.75H8.3125C8.06641 15.75 7.875 15.5586 7.875 15.3125V11.8125C7.875 11.5937 8.06641 11.375 8.3125 11.375ZM9.1875 14.875C9.40625 14.875 9.625 14.6836 9.625 14.4375V12.6875C9.625 12.4687 9.40625 12.25 9.1875 12.25H8.75V14.875H9.1875ZM11.375 11.8125C11.375 11.5937 11.5664 11.375 11.8125 11.375H13.125C13.3438 11.375 13.5625 11.5937 13.5625 11.8125C13.5625 12.0586 13.3438 12.25 13.125 12.25H12.25V13.125H13.125C13.3438 13.125 13.5625 13.3437 13.5625 13.5625C13.5625 13.8086 13.3438 14 13.125 14H12.25V15.3125C12.25 15.5586 12.0313 15.75 11.8125 15.75C11.5664 15.75 11.375 15.5586 11.375 15.3125V13.5625V11.8125Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_314_3">
        <rect width="14" height="19" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
